import { SHTypography } from "@components/design-systems";
import { memo } from "react";

interface SummaryAnalysisTableTotalSelectedCellProps {
  totalFeatures?: number;
  totalFeaturesSelected?: number;
}
export const SummaryAnalysisTableTotalSelectedCell = memo(
  ({
    totalFeatures,
    totalFeaturesSelected,
  }: SummaryAnalysisTableTotalSelectedCellProps) => {
    return (
      <SHTypography variant="subtitle2" sx={{ textAlign: "center" }}>
        {totalFeaturesSelected}/{totalFeatures}
      </SHTypography>
    );
  },
);
